import { useState } from 'react';
import styled from 'styled-components';

import Viewer from 'components/layer/Viewer';

import { font } from 'asserts/styles/fonts';
import { color } from 'asserts/styles/colors';
import { ReactComponent as IconSearch } from 'asserts/icons/ic_search_lined_guide.svg';
import { ReactComponent as IconInfo } from 'asserts/icons/ic_info_circle_lined.svg';

import { Table, type TableProps } from 'antd';
import BIzTypeModal from 'components/modal/BIzTypeModal';

const Info = () => {
  const data = [
    {
      title: 'Posture 기본',
      dec: '생체역학적 자세 측정',
      text: '근골격계 불균형 및 부정렬에 대한 정적자세 분석',
      images: ['Report_Posture_01', 'Report_Posture_02', 'Report_Posture_03'],
      thumbnail: 'Image_Posture'
    },
    {
      title: 'Posture 전문가',
      dec: '생체역학적자세 측정',
      text: '근골격계불균형 및 부정렬에대한 정적자세 ​분석',
      images: ['Report_Posture_Pro_01', 'Report_Posture_Pro_02', 'Report_Posture_Pro_03'],
      thumbnail: 'Image_Posture_Pro'
    },
    {
      title: 'Manual',
      dec: 'Q앵글·사용자정의 검사',
      text: '사용자의 다양한 관점을 분석하기 위한 체형 측정',
      images: ['Report_Manual_01', 'Report_Manual_02'],
      thumbnail: 'Image_Manual'
    },
    {
      title: 'Moire',
      dec: '척추·근육3D형상측정',
      text: '3D근육형상 측정을 통한 신체의 회전 및 척추 만곡 상태 확인',
      images: ['Report_Moire'],
      thumbnail: 'Image_Moire'
    },
    {
      title: 'ROM',
      dec: '척추·관절 가동범위 검사',
      text: '엑스바디의 Posture Analysis 를 통해 근골격 불균형 및 부정렬 등에 대한 생체역학적 분석 결과를 만나보세요!',
      images: ['Report_Rom_01', 'Report_Rom_02', 'Report_Rom_03'],
      thumbnail: 'Image_ROM'
    },
    {
      title: 'Movement Squat',
      dec: '실시간 동작 측정',
      text: '자동관절인식 기술을 이용한 실시간 움직임 측정',
      images: ['Report_Squat_01', 'Report_Squat_02', 'Report_Squat_03', 'Report_Squat_04'],
      thumbnail: 'Image_Squat'
    },
    {
      title: 'Movement Golf',
      dec: '골프 동작 불균형 측정',
      text: '골프 동작을 방해하는 기동들을 분석',
      images: ['Report_Golf'],
      thumbnail: 'Image_Golf'
    }
  ];

  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState<string[] | string>('');
  const [selectedTitle, setSelectedTitle] = useState('null');
  const [isOpenModal, setIsOpenModal] = useState(false);

  const openViewer = () => {
    setIsViewerOpen(true);
    document.body.style.overflow = 'hidden';
  };

  const closeViewer = () => {
    setIsViewerOpen(false);
    document.body.style.overflow = 'visible';
  };

  const handleClickOpenViewer = (image: string[] | string, title: string) => {
    openViewer();
    setSelectedItem(image);
    setSelectedTitle(title);
  };

  const handleClickOpenModal = () => {
    setIsOpenModal(true);
  };

  const handleClickCloseModal = () => {
    setIsOpenModal(false);
  };

  const columns: TableProps<any>['columns'] = [
    {
      title: '구분',
      dataIndex: 'name',
      key: 1,
      colSpan: 2,
      onCell: (_, index) => {
        if (index === 0) {
          return { rowSpan: 2 };
        }
        if (index === 1) {
          return { rowSpan: 0 };
        }

        if (index === 2) {
          return { rowSpan: 2 };
        }
        if (index === 3) {
          return { rowSpan: 0 };
        }

        return {};
      }
    },
    {
      dataIndex: 'age',
      colSpan: 0
    },
    {
      title: '비즈니스 타입',
      children: [
        {
          title: 'B2B',
          dataIndex: 'b2b',
          key: '1'
        },
        {
          title: 'B2C',
          dataIndex: 'b2c',
          key: '2'
        }
      ],
      key: 2
    }
  ];

  const tableData = [
    {
      key: '1',
      name: '기본 이용료',
      age: '지불 주체',
      b2b: '비즈멤버',
      b2c: '비즈멤버'
    },
    {
      key: '2',
      age: '지불 방법',
      b2b: '월구독 or 연구독',
      b2c: '월구독 or 연구독'
    },
    {
      key: '3',
      name: '검사 이용료',
      age: '지불 주체',
      b2b: '비즈멤버',
      b2c: '매장 방문고객'
    },
    {
      key: '4',
      name: '검사 이용료',
      age: '지불 방법',
      b2b: '월구독',
      b2c: '검사 건당 결제'
    }
  ];
  return (
    <>
      <Wrapper>
        <TitleWrapper>
          <h2>
            <pre>{`엑스바디 통합프로그램의\n다양한 검사를 만나보세요.`}</pre>
          </h2>
          <img src="/images/guide_ticket.png" alt="티켓 이미지" />
        </TitleWrapper>
        <ContentsWrapper>
          <CostInfoWrapper>
            <h3>검사비용</h3>
            <h4>
              비즈멤버 가입 시 선택한 ‘비즈니스 타입’에 따라서 엑스바디 검사비용을 지불하는 주체가
              다릅니다.
            </h4>
            <p className="inforBtn" onClick={handleClickOpenModal}>
              비즈니스 타입 <IconInfo fill="#66B6FF" />
            </p>
            <Table columns={columns} dataSource={tableData} pagination={false} bordered />
            <p className="costInfo">
              * 각 검사 별 비용은 구매하는 멤버십에서 지정한 금액으로 결제 됩니다.
            </p>
          </CostInfoWrapper>

          {data.map((item, index) => (
            <Contents key={index} $isEven={index % 2 === 0}>
              <InnerWrapper>
                <TextWrapper>
                  <h3>{item.title}</h3>
                  <h4>{item.dec}</h4>
                  <p>{item.text}</p>
                </TextWrapper>
                <ReportWrapper>
                  {item.images.slice(0, 3).map((image, imageIndex) => (
                    <div
                      key={imageIndex}
                      onClick={() => handleClickOpenViewer(item.images, item.title)}
                    >
                      <img
                        key={imageIndex}
                        src={`/images/${image}.png`}
                        alt={`티켓 이미지 ${imageIndex}`}
                        loading="lazy"
                      />
                      <HoverWrapper className="hover">
                        <IconWrapper className="hover-icon">
                          <IconSearch />
                        </IconWrapper>
                      </HoverWrapper>
                    </div>
                  ))}
                </ReportWrapper>
              </InnerWrapper>
              <Thumbnail>
                <img
                  className="thumbnail"
                  src={`/images/${item.thumbnail}.png`}
                  alt="티켓 이미지"
                  loading="lazy"
                />
              </Thumbnail>
            </Contents>
          ))}
        </ContentsWrapper>
      </Wrapper>
      {isOpenModal && <BIzTypeModal open={isOpenModal} onCancel={handleClickCloseModal} />}
      {isViewerOpen && (
        <Viewer
          onClose={closeViewer}
          selectedItem={selectedItem}
          selectedTitle={selectedTitle}
          type={'image'}
        />
      )}
    </>
  );
};

export default Info;

const Wrapper = styled.div`
  width: 890px;
  margin: 0 auto;
  color: ${color.navyLight};

  img.thumbnail {
    border-radius: 24px;
  }

  h3 {
    ${font.h1_bold};
  }

  h4 {
    ${font.h3_medium};
  }

  p {
    color: ${color.gray600};
    ${font.h4_regular};
  }

  p.inforBtn {
    display: flex;
    align-items: center;
    gap: 8px;
    color: ${color.blue};
    ${font.body_medium};
    cursor: pointer;
  }

  p.costInfo {
    ${font.caption1_regular};
  }
`;
const TitleWrapper = styled.div`
  display: flex;
  position: relative;
  padding: 72px 0 120px;

  img {
    position: absolute;
    top: 0;
    right: -51px;
  }
`;

const CostInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  .ant-table-wrapper table th,
  .ant-table-wrapper table td {
    vertical-align: middle;
    text-align: center;
  }
  .ant-table-wrapper .ant-spin-container table thead tr:last-of-type th {
    font-weight: 700;
  }

  .ant-table-wrapper table tbody {
    color: ${color.black2};
  }
`;

const ContentsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 128px;
`;

const Contents = styled.div<{ $isEven: boolean }>`
  display: flex;
  justify-content: space-between;
  gap: 48px;
  flex-direction: ${({ $isEven }) => ($isEven ? 'row' : 'row-reverse')};
`;

const InnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 24px;
  width: 100%;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const ReportWrapper = styled.div`
  display: flex;
  gap: 12px;
  cursor: pointer;

  & > div {
    position: relative;
    width: 136px;
    height: 192px;
    box-shadow: 0px 0px var(--Blur-Blur-16, 16px) 0px
      var(--opacity-black-black-20, rgba(0, 0, 0, 0.2));
  }

  img:hover + .hover,
  .hover:hover {
    opacity: 1;
  }

  img {
    position: relative;
    width: 136px;
    height: 192px;
  }
`;

const HoverWrapper = styled.div`
  position: absolute;
  background-color: rgba(0, 0, 0, 0.5);
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: all 0.3s;
`;

const IconWrapper = styled.p`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 32px;
  background: ${color.gradientType1};
  width: 52px;
  height: 52px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const Thumbnail = styled.div`
  width: 408px;
  height: 480px;

  img {
    width: 408px;
    height: 480px;
  }
`;

// const PriceWrapper = styled.div`
//   display: flex;
//   align-items: center;
//   gap: 16px;

//   div {
//     display: flex;
//     padding: 8px 16px;
//     align-items: center;
//     gap: 8px;
//     border-radius: 24px;
//     background: ${color.black2};
//     color: ${color.white2};
//     ${font.body_medium};
//   }

//   p {
//     color: ${color.black2};
//     ${font.h3_bold};
//   }
// `;
